import Axios from "./axios";

const resource = "tele-treatments";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}